// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2nYN1","paymentContainer":"PaymentPage_paymentContainer__3OETh"};